<script setup lang="ts">
defineProps<{
  href: string,
  icon: string,
  modifierClass: string,
  text: string
}>()
</script>

<template>
  <div :class="modifierClass">
    <a :href="href"
       target="_blank"
       rel="nofollow noopener"
       :class="`icon icon--social-share icon-${icon}`">
      <svg><use :href="`#${icon}`" /></svg>
      <span class="bx-social-share__text">
        {{ text }}
      </span>
    </a>
  </div>
</template>
